import { render, staticRenderFns } from "./agingrekapcust.vue?vue&type=template&id=767dbead"
import script from "./agingrekapcust.vue?vue&type=script&lang=js"
export * from "./agingrekapcust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports